/**
 * src/utils/frequentExpenses.ts
 * Frequent & Recent Transaction Presets for 1-Tap Quick Selection
 */

export interface ExpensePreset {
  label: string;
  amount: number;
  description: string;
  categoryName: string;
  icon?: string;
}

export const DEFAULT_EXPENSE_PRESETS: ExpensePreset[] = [
  { label: 'Chai', amount: 20, description: 'Cutting Chai', categoryName: 'Tea, Soda & Snacks', icon: '☕' },
  { label: 'Tea & Snacks', amount: 35, description: 'Tea & Snacks', categoryName: 'Tea, Soda & Snacks', icon: '☕' },
  { label: 'Cold Drink / Soda', amount: 20, description: 'Soda / Cold Drink', categoryName: 'Tea, Soda & Snacks', icon: '🥤' },
  { label: 'Vadapav', amount: 40, description: 'Vadapav', categoryName: 'Food & Meals', icon: '🍔' },
  { label: 'Lunch', amount: 150, description: 'Afternoon Lunch', categoryName: 'Food & Meals', icon: '🍽️' },
  { label: 'Dinner', amount: 250, description: 'Dinner with Team', categoryName: 'Food & Meals', icon: '🍽️' },
  { label: 'Petrol / Fuel', amount: 100, description: 'Bike Petrol', categoryName: 'Travel & Transport', icon: '⛽' },
  { label: 'Milk', amount: 35, description: 'Milk', categoryName: 'General', icon: '🥛' },
  { label: 'GPay Settlement', amount: 500, description: 'Google Pay Settle', categoryName: 'Cash', icon: '⚡' },
];

const RECENT_PRESETS_KEY = 'ckaudit_recent_user_presets';

export function getRecentPresets(): ExpensePreset[] {
  try {
    const raw = localStorage.getItem(RECENT_PRESETS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.slice(0, 6);
    }
  } catch {}
  return [];
}

export function saveRecentPreset(preset: ExpensePreset) {
  try {
    const current = getRecentPresets().filter(
      p => p.description.toLowerCase() !== preset.description.toLowerCase() || p.amount !== preset.amount
    );
    const updated = [preset, ...current].slice(0, 8);
    localStorage.setItem(RECENT_PRESETS_KEY, JSON.stringify(updated));
  } catch {}
}
